import { convertKeysToCamelCase } from '@community_dev/requests'
import camelCase from 'lodash/camelCase'
import set from 'lodash/fp/set'
import get from 'lodash/get'
import omit from 'lodash/omit'

/**
 * Returns a response transformer that deep-camelCases keys like the default
 * `convertKeysToCamelCase`, but leaves any subtree located at one of the given
 * snake_case `paths` untouched. The path is matched against the raw
 * (pre-transform) shape, e.g. `data.upload_headers`.
 *
 * The key for the excluded path is still camelCased on its parent
 * (`data.upload_headers` -> `data.uploadHeaders`); only the value is preserved.
 */
export function toTransformExceptFn(...paths: string[]) {
  return (raw: unknown): any =>
    paths.reduce((acc, path) => {
      const value = get(raw, path)
      if (value === undefined) return acc
      const camelPath = path.split('.').map(camelCase).join('.')
      return set(camelPath, value, acc)
    }, convertKeysToCamelCase(omit(raw as object, paths)))
}
